export default {
  yourSelectedLocation: '17092025-082054-0000',
  people: '18112016-101623-2917',
  person: '13122016-154553-6551',
  roomDetails: '17092025-082054-0001',
  bookingDetails: '18112016-153301-3489',
  optionalAddOns: '17092025-082054-0002',
  wiFiAndOnsiteReception: '17092025-082054-0003',
  includedInYourBooking: '17092025-082054-0004',
  included: '08022016-155021-8000',
  excVatAndTaxes: '17092025-082054-0005',
  exterior: '01122021-112529-0001',
  interior: '29012024-114834-0007',
  stunningView: '11042024-135122-0007',
  dueToday: '26032020-094608-0036',
};
